module.exports = __webpack_public_path__ + "static/iraivan-1-d990700b50ad693bb47a74b2f615b5f2.jpg";